import React, { useEffect, useState } from 'react';
import { useConfig } from '../helpers/useConfig';
import { getCals, getDuoRomanaExtras, getExtras } from '../helpers/basketHelpers';
import { useBreakPoint } from '../hooks/useBreakPoint';
import useWindowDimensions from '../hooks/useWindowDimensions';
import minus from '../img/icons/basket-card-minus.svg';
import plus from '../img/icons/basket-card-plus.svg';
import { useSelector } from 'react-redux';
import DietaryIcons from './DietaryIcons';
import DuoRomanaExtras from './DuoRomanaExtras';
import { useAppSelector } from '../store/storeTypes';

export const getItemExtras = (item, isBundle, isDuoRomana, isPiccolo, doughStickOptionIds) => {
    return isDuoRomana ? getDuoRomanaExtras(item) : getExtras(item, isBundle, isPiccolo, doughStickOptionIds);
}

export const BasketItem = (props) => {
  const { id, name, cost, calculatedCost, imageUrl, quantity, subProducts, customID, basePrice, dietPreferences, fallbackImageUrl } = props.item;
  const { addItem, removeItem, navigateTo, isBundle, hidePiccoloCalories } = props;
  const dimensions = useWindowDimensions();
  const config = useConfig();
  const duoRomanaIds = useSelector(state => state.session.frontEndConfig?.duoRomanaIds);
  const isDuoRomana = duoRomanaIds?.includes(id);
  const piccoloMenuIds = useSelector(state => state.session.frontEndConfig?.piccoloMenuIds);
  const isPiccolo = piccoloMenuIds?.includes(id);
  const [extras, setExtras] = useState();
  const baseSelections = useSelector(state => state.menu.baseSelections);
  const [selectedBaseCost, setSelectedBaseCost] = useState(cost || basePrice);
  const showCalories = useAppSelector(state => state.menu.showCalories);
  const doughStickOptionIds = useSelector(state => state.session.frontEndConfig?.doughStickOptionIds);
  /* AB- This comment is true as at 29/9/2023 with the code and style as we have now
   * The breakpoint of 1026 is required for controlling the top margin of dietary icons in this card.
   * If other breakpoints are required do not alter this one but create new ones.
   */
  const mediumScreen = useBreakPoint(dimensions?.width ?? 0, 1026);

  useEffect(() => {
    if (subProducts && subProducts[0].subProducts.length > 1) {
      const matchingBaseSelection = baseSelections.find(b => b.product === id);
      if (matchingBaseSelection) {
        setSelectedBaseCost(subProducts[0].subProducts.find(s => s.id === matchingBaseSelection.base).cost);
      } else {
        setSelectedBaseCost(subProducts[0].subProducts[1].cost);
      }
    }
  }, [subProducts, baseSelections]);

  useEffect(() => {
      setExtras(getItemExtras(props.item, isBundle, isDuoRomana, isPiccolo, doughStickOptionIds));
  }, [props.item]);

  let displayCost = calculatedCost || selectedBaseCost;
  if (!displayCost) displayCost = 0;

  let discountTotal = 0;
  const discounts = props?.discounts?.filter(d => d.id === id || d.id === customID) || [];
  discounts.forEach(discount => discountTotal += discount.amount);
  const displayCostAfterDiscount = displayCost - discountTotal;
  
  const getCalories = () => {
    if (props.hideCalories || hidePiccoloCalories || !showCalories) return null;
    return getCals(props.item, null);
  };

  return (
    <div className='new-basket-item-container'>
      <div className='image-container'>
              <picture>
                  <img
                      className="image threebyfour basket-item-image"
                      src={imageUrl}
                      alt='food item'
                      onError={(e) => { if (fallbackImageUrl && e.currentTarget.src !== fallbackImageUrl) e.currentTarget.src = fallbackImageUrl; }}
                  />
              </picture>
      </div>
      <div className='info-container'>
        <p
          className="info-title"
        >
          {name}
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
          {discounts?.length > 0 ? <div><small><strike>{config?.CURRENCY_SYMBOL}{displayCost.toFixed(2)}</strike></small>&nbsp;<span className="is-text-weight-semibold">{displayCostAfterDiscount !== 0 ? <>{config.CURRENCY_SYMBOL}{(displayCostAfterDiscount).toFixed(2)}</> : <>Free</>}</span></div>
            : <span className="total-price">{config?.CURRENCY_SYMBOL}{displayCost.toFixed(2)}</span>}
          {getCalories()}
          {(extras && !isDuoRomana) ? <span className='pizza-base'>{extras.base}</span> : null}
        </div>
      </div>
      {
        extras && (extras.includedToppings?.length || extras.excludedToppings?.length || extras.items?.length) ||
          (isDuoRomana && extras?.length >= 0) ?
          <div className='extras-container'>
            <div className='is-flex is-flex-direction-column extras'>
              {
                !isDuoRomana ?
                  <>
                    {extras.includedToppings?.map((el, idx) => <div key={idx} className='is-flex is-justify-content-space-between-mobile is-justify-content-flex-start-tablet basket-card-extra'><p>- {el.name}</p></div>)}
                    {extras.excludedToppings?.map((el, idx) => <div key={idx} className='is-flex is-justify-content-space-between-mobile is-justify-content-flex-start-tablet basket-card-extra'><p>+ {el.name}</p>{el.cost > 0 ? <p className='price'>{`${config.CURRENCY_SYMBOL}${el.cost.toFixed(2)}`}</p> : null}</div>)}
                    {extras.items?.map((el, idx) => <div key={idx} className='is-flex is-justify-content-space-between-mobile is-justify-content-flex-start-tablet basket-card-extra' ><p>{el.quantity} x {el.name}</p></div>)}
                  </>
                  :
                  <DuoRomanaExtras extras={extras} currencySymbol={config.CURRENCY_SYMBOL}></DuoRomanaExtras>
              }
            </div>
          </div>
          : null
      }
      <div className='dietary-container'>
        {dietPreferences && !isDuoRomana
          && <DietaryIcons icons={dietPreferences} style={{ justifyContent: 'flex-end', marginTop: `${mediumScreen ? '2px' : '4px'}` }} />}
      </div>
      <div className='buttons-container'>
        {!props.outOfStock && (
          <div className="block is-flex is-justify-content-flex-end">
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              {
                customID &&
                <a
                  role="button"
                  className="link dm-sans"
                  style={{ paddingRight: '0.5rem' }}
                  onClick={() => {
                    const portionId = props.item.availablePortionIds?.join('|') ?? subProducts?.[0]?.subProducts?.map(sp => sp.id).join('|') ?? '';
                    navigateTo(`/${isBundle ? 'bundle' : 'customise'}/${isBundle ? encodeURIComponent(name) : id}?customId=${customID}&name=${encodeURIComponent(name)}&portionId=${encodeURIComponent(portionId)}`);
                  }}
                >Edit</a>
              }
              <img alt="minus" aria-label="decrease" src={minus} className="icon is-medium" onClick={() => removeItem(props.item)} data-testid='decrease' />
              <p className='basket-card-quantity' data-testid='quantity'>{quantity}</p>
              <img alt="plus" aria-label="increase" src={plus} className="icon is-medium" onClick={() => addItem(props.item)} data-testid='increase' />
            </div>
          </div>)}
      </div>
    </div>
  );
};